import React from "react";

function Footer() {
  return (
    <footer className="bg-black text-gray-400 px-4 py-6 text-center text-sm sm:text-base border-t border-red-500 hover:text-red-500 transition duration-300">
      © 2025, Muazam Syed. Made with React.js, Tailwind CSS, Node.js, and MySQL.
    </footer>
  );
}

export default Footer;
